import { AnswerByCategoryView, inputPinPhases } from '../../playerStore.types';
import { PlayerPinReducer, PlayerPinReducerFactory } from '../reducers.types';
import { nextPhase } from '../reducers.utils';
import {
  createAnswerByCategoryOrderHandler,
  extractCategories,
  updateAnswerByCategoryPinState,
} from './answerByCategoryReducer.utils';

export type AnswerByCategoryReducer = PlayerPinReducer<AnswerByCategoryView>;

export const createAnswerByCategoryReducer: PlayerPinReducerFactory<AnswerByCategoryView> = () =>
  answerByCategoryReducer;

const answerByCategoryReducer: AnswerByCategoryReducer = {
  phases: inputPinPhases,
  initial: (state, history) => {
    const pinId = state.currentPinId;
    if (!pinId) {
      return {
        type: 'ANSWER_BY_CATEGORY',
        phase: 'input',
      };
    }

    const currentPin = state.assignment?.pins[pinId];
    const categories = extractCategories(currentPin);

    const existingPinState = state.pinState[pinId]?.answerByCategory;
    const orderHandler = createAnswerByCategoryOrderHandler(existingPinState?.lastOrder);

    const viewForUpdate = history ?? { type: 'ANSWER_BY_CATEGORY', phase: 'input' };

    updateAnswerByCategoryPinState(state, pinId, viewForUpdate, orderHandler, categories);

    return {
      type: 'ANSWER_BY_CATEGORY',
      phase: 'input',
    };
  },
  hasNextView: (state, currentView, direction) => {
    return nextPhase(currentView.phase, answerByCategoryReducer.phases, direction) !== null;
  },
  handleNextView: (state, prev, direction) => {
    if (!state.currentView) {
      return false;
    }

    const next = nextPhase(prev.phase, answerByCategoryReducer.phases, direction);
    if (next) {
      return {
        ...prev,
        type: 'ANSWER_BY_CATEGORY',
        phase: next,
      };
    }
    return false;
  },
  onEntriesUpdate: (state, currentView) => {
    const pinId = state.currentPinId;
    if (!pinId) return currentView;

    const currentPin = state.assignment?.pins[pinId];
    const categories = extractCategories(currentPin);

    // Get existing state to preserve the lastOrder for proper order handler initialization
    const existingPinState = state.pinState[pinId]?.answerByCategory;
    const orderHandler = createAnswerByCategoryOrderHandler(existingPinState?.lastOrder);

    updateAnswerByCategoryPinState(state, pinId, currentView, orderHandler, categories);

    return {
      ...currentView,
      type: 'ANSWER_BY_CATEGORY',
    };
  },
};
